module.exports = __webpack_public_path__ + "static/media/post-update.b5757e23.svg";